import NP from "../../../1. Core/NP";
import Control from "../../../1. Core/Control";
import ListGroupHeader from "../../../1. Core/Controls/ListBox/ListGroupHeader";
import Delegate from "../../../1. Core/Delegate";
import IconSelect from "../../../1. Core/Controls/Select/IconSelect";
import {getTournaments, ITournament} from "../../Util";
import {SportType} from "../../types";
import Select from "../../../1. Core/Controls/Select/Select";

export default class TEventListFilterPanel extends Control {

	public EvFilterSortChanged: Delegate;

	private _sortFieldCombo: IconSelect;
	private _sortDirectionCombo: IconSelect;
	private _sortLabel: ListGroupHeader;
	private _tournamentCombo: IconSelect;
	private _showNonStarted: Select;
	private _SportType: SportType;

	_initFields(settings: object)
	{
		this._SportType = SportType.MMA;
		this.EvFilterSortChanged = new Delegate();
		super._initFields(settings);
	}

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="filter-panel"></div>');

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'Parameters',
			Class: 'app-list-group__subheader--accent'
		});

		this._tournamentCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Tournaments'),
			EvItemSelected: async () =>
			{
				this._applyFiltersSort();
			}
		});

		this._showNonStarted = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Filter'),
			Value: 'All',
			Items: [{RK: 'All', Value: 'All', FontImage: NP.FontImages.event}, {
				RK: 'NotStarted',
				Value: 'NotStarted',
				FontImage: NP.FontImages.event
			}, {RK: 'Ended', Value: 'Ended', FontImage: NP.FontImages.event}],
			EvItemSelected: async () =>
			{
				this._applyFiltersSort();
			}
		});

		this._showNonStarted.setValue('All', false)

		this._sortLabel = new ListGroupHeader({
			ParentNode: this._root,
			RK: 'OrderBy',
			Class: 'app-list-group__subheader--accent'
		});

		this._sortFieldCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 4,
			Items: [{
				Value: 'Id',
				FontImage: NP.FontImages.sort,
				Content: 'Id'
			}, {
				Value: 'Name',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByName')
			}, {
				Value: 'Tournament',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('Tournament')
			}, {
				Value: 'BattleCount',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('BattleCount')
			}, {
				Value: 'Date',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('Date')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._sortDirectionCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: -1,
				FontImage: NP.FontImages.arrow_downward,
				Content: NP.RM.getString('Desc')
			}, {
				Value: 1,
				FontImage: NP.FontImages.arrow_upward,
				Content: NP.RM.getString('Asc')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._renderItems([this._root], this._ParentNode || document.documentElement);
		this.loadFilters();
	}

	setSortVisible(value: boolean)
	{
		NP.setIsVisible([this._sortLabel, this._sortDirectionCombo, this._sortFieldCombo], value)
	}

	async loadFilters()
	{
		let tournaments = await getTournaments(this._SportType) as ITournament[],
			 items = tournaments.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name})),
			 defaultItems = [{
				 Value: null as any,
				 FontImage: NP.FontImages.event,
				 Content: NP.RM.getString('AllTournaments')
			 }];
		this._tournamentCombo.clear();
		this._tournamentCombo.addItems(defaultItems);
		this._tournamentCombo.addItems(items)
		this._tournamentCombo.setSelectedIndex(0, false);
	}

	_applyFiltersSort()
	{
		this.EvFilterSortChanged.fire(this, this.getFilterData())
	}

	getFilterData()
	{
		return {
			From: this._showNonStarted.getValue(),
			TournamentId: this._tournamentCombo.getValue(),
			SortField: this._sortFieldCombo.getValue(),
			SortDirection: this._sortDirectionCombo.getValue()
		}
	}

	setSortValues(sortField: string, sortDirection: number)
	{
		this._sortFieldCombo.setValue(sortField, false);
		this._sortDirectionCombo.setValue(sortDirection, false);
	}
}